import { Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FeedbackProps {
  feedbackNPSWidget: () => void;
  dismissNPSWidget: () => void;
}
const FeedbackSurvey = ({dismissNPSWidget, feedbackNPSWidget}: FeedbackProps) => {
  const { t } = useTranslation("feedback");
  return (
    <Box sx={{
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingLeft: "10px",
      paddingRight: "10px",
      "@media (max-width: 414px)": {
        marginBottom: "10px",
        "p": {
          fontSize: "14px",
          flex: "1 1 0"
        }
      }
    }}>
        <Typography variant="body3">{t("recommendationLikelihood")}</Typography>
        <Box sx={{
          "@media (max-width: 414px)": {
            flex: "1 1 0",
            textAlign: "center"
          }
        }}>
          <Button onClick={dismissNPSWidget} variant="text" sx={{marginRight: "15px", color: (theme) => theme.palette.text.primary}}>{t("dismiss", { ns: "common" })}</Button>
          <Button onClick={feedbackNPSWidget} variant="outlined">{t("leaveFeedback")}</Button>
        </Box>
    </Box>
    )
}

export default FeedbackSurvey
